// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__WDxUo","footer":"ModalCreateQualiphyProcedure_footer__3YFRX","additionData":"ModalCreateQualiphyProcedure_additionData__3TWvW"};